"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";
import { cn } from "@v3/_/lib/utils";
function TooltipProvider(t0) {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      delay: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const delay = t1 === undefined ? 0 : t1;
  let t2;
  if ($[3] !== delay || $[4] !== props) {
    t2 = <TooltipPrimitive.Provider data-slot="tooltip-provider" delay={delay} {...props} />;
    $[3] = delay;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export const BASE_TOOLTIP_DELAY = 300;
function Tooltip(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function TooltipTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function TooltipContent(t0) {
  const $ = _c(23);
  let anchor;
  let children;
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      className,
      side: t1,
      sideOffset: t2,
      align: t3,
      alignOffset: t4,
      anchor,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = anchor;
    $[2] = children;
    $[3] = className;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    anchor = $[1];
    children = $[2];
    className = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  const side = t1 === undefined ? "top" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  const align = t3 === undefined ? "center" : t3;
  const alignOffset = t4 === undefined ? 0 : t4;
  let t5;
  if ($[9] !== className) {
    t5 = cn("data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 bg-foreground text-background z-50 w-fit max-w-xs origin-(--transform-origin) rounded-md px-3 py-1.5 text-xs **:data-[slot=kbd]:rounded-md", className);
    $[9] = className;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TooltipPrimitive.Arrow className="bg-foreground fill-foreground z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] data-[side=bottom]:top-1 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== props || $[14] !== t5) {
    t7 = <TooltipPrimitive.Popup data-slot="tooltip-content" className={t5} {...props}>{children}{t6}</TooltipPrimitive.Popup>;
    $[12] = children;
    $[13] = props;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== align || $[17] !== alignOffset || $[18] !== anchor || $[19] !== side || $[20] !== sideOffset || $[21] !== t7) {
    t8 = <TooltipPrimitive.Portal><TooltipPrimitive.Positioner anchor={anchor} align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset} className="isolate z-50">{t7}</TooltipPrimitive.Positioner></TooltipPrimitive.Portal>;
    $[16] = align;
    $[17] = alignOffset;
    $[18] = anchor;
    $[19] = side;
    $[20] = sideOffset;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };